import React from 'react';
import {useAppSelector} from "../../../../../../common/hook";
import {getProfileData} from "../../../../../../entities/Profile/model/selectors/getProfileData/getProfileData";
import {
    ADDRESS,
    BIRTHDATE,
    COUNTRY,
    CURRENT_DATE_TIME,
    EMAIL,
    MOBILE_PHONE,
    SOCIAL_MEDIA,
    TIME_ZONE
} from "../../../../../../entities/constants/constants";
import {ReactComponent as FacebookIcon} from '../../../../../../assets/main/profile-box/social-network/facebook.svg';
import {ReactComponent as InstagramIcon} from '../../../../../../assets/main/profile-box/social-network/instagram.svg';
import {ReactComponent as TelegramIcon} from '../../../../../../assets/main/profile-box/social-network/telegram.svg';
import {ReactComponent as ViberIcon} from '../../../../../../assets/main/profile-box/social-network/viber.svg';
import {ReactComponent as VKontakteIcon} from '../../../../../../assets/main/profile-box/social-network/vkontakte.svg';
import {ReactComponent as WhatsappIcon} from '../../../../../../assets/main/profile-box/social-network/whatsapp.svg';


type SocialIcon = React.ComponentType<React.SVGProps<SVGSVGElement> & { title?: string | undefined }>;

const socialIcons: Record<string, SocialIcon> = {
    Facebook: FacebookIcon,
    Instagram: InstagramIcon,
    Telegram: TelegramIcon,
    Viber: ViberIcon,
    VKontakte: VKontakteIcon,
    Whatsapp: WhatsappIcon,
};

const InfoTeacher = () => {
    const data = useAppSelector(getProfileData)



    return (
        <>
            <div className="data-cards-box">
                <div className="data-card">
                    <div className="row">
                        <p className="row-title">{BIRTHDATE}</p>
                        <p>{data?.birthDate} г.</p>
                    </div>
                    <div className="row">
                        <p className="row-title">{EMAIL}</p>
                        <p>
                            <a href={`mailto:${data?.email}`}>
                                {data?.email}
                            </a>
                        </p>
                    </div>
                    <div className="row">
                        <p className="row-title">{MOBILE_PHONE}</p>
                        <p>
                            <a href={`tel:${data?.phone}`}>
                                {data?.phone}
                            </a>
                        </p>
                    </div>
                </div>
                <div className="data-card">
                    <div className="row">
                        <p className="row-title">{TIME_ZONE}</p>
                        <p>{data?.timeZone}</p>
                    </div>
                    <div className="row">
                        <p className="row-title">{CURRENT_DATE_TIME}</p>
                        <p>{data?.date},{" "}{data?.time}</p>
                    </div>
                    <div className="row">
                        <p className="row-title">{COUNTRY}</p>
                        <p>{data?.country}</p>
                    </div>
                    <div className="row">
                        <p className="row-title">{ADDRESS}</p>
                        <p>{data?.address}</p>
                    </div>
                </div>
                {data?.socials &&  data?.socials.length > 0 && (
                    <div className="data-card">
                        <div className="row">
                            <p className="row-title">{SOCIAL_MEDIA}</p>
                            <div className="social-links">
                                {data?.socials.map((social, index) => {
                                    const SocialIcon = socialIcons[social.name];
                                    return social.link ? (
                                        <p className="p-icon" key={index}>
                                            <a href={social.link} target="_blank" rel="noopener noreferrer">
                                                {social.name}
                                            </a>
                                            {SocialIcon && <SocialIcon className="icon" />}
                                        </p>
                                    ) : null;
                                })}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>

    );
};

export default InfoTeacher;
